import { render } from "./ViewOutputForm.vue?vue&type=template&id=0cea56ce"
import script from "./ViewOutputForm.vue?vue&type=script&lang=js"
export * from "./ViewOutputForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__